import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['form', 'submitButton', 'titleInput'];

  connect() {
    this.validateOnSubmit();
  }

  validateOnSubmit() {
    const form = this.element.closest('form');
    if (form) {
      form.addEventListener('submit', (event) => {
        if (!this.validate()) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    }
  }

  validate() {
    let isValid = true;
    const errors = [];

    const titleInput = this.element.querySelector('input[name="title"]');
    if (titleInput && !titleInput.value.trim()) {
      errors.push('O título é obrigatório');
      this.showError(titleInput, 'Por favor, insira um título');
      isValid = false;
    }

    const summernoteController = this.application.getControllerForElementAndIdentifier(
      this.element.querySelector('[data-controller="v3--summernote--controller"]'),
      'v3--summernote--controller',
    );

    if (summernoteController && summernoteController.isEmpty()) {
      errors.push('A descrição é obrigatória');
      const summernoteElement = summernoteController.element;
      this.showError(summernoteElement, 'Por favor, insira uma descrição');
      isValid = false;
    }

    if (!isValid) {
      this.showToast(errors.join('. '));
    }

    return isValid;
  }

  showError(element, message) {
    const existingError = element.parentElement.querySelector('.tw-text-red-500');
    if (existingError) {
      existingError.remove();
    }

    const errorElement = document.createElement('span');
    errorElement.className = 'tw-text-red-500 tw-text-sm tw-mt-1';
    errorElement.textContent = message;
    element.parentElement.appendChild(errorElement);

    element.classList.add('tw-border-red-500');

    const removeError = () => {
      element.classList.remove('tw-border-red-500');
      errorElement.remove();
      element.removeEventListener('input', removeError);
    };
    element.addEventListener('input', removeError);
  }

  showToast(message) {
    if (window.Flash) {
      window.Flash.error(message);
    } else {
      alert(message);
    }
  }
}
